var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor forward-to-chatbot" }, [
    _c("div", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("chatbotv2.forwardToChatbotBlockTitle"))),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mt-3" }, [
      _c(
        "div",
        { staticClass: "attribute-picker-section" },
        [
          _c("span", { staticClass: "sectionTitle" }, [
            _vm._v(_vm._s(_vm.$t("chatbotv2.forwardToChatbotChooseStory"))),
          ]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticClass: "select-filetype",
              model: {
                value: _vm.clone.storyId,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "storyId", $$v)
                },
                expression: "clone.storyId",
              },
            },
            _vm._l(_vm.stories, function (story) {
              return _c(
                "a-select-option",
                { key: story._id, attrs: { value: story._id } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(story.title) +
                      "\n                "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mt-3" }, [
      _c("div", { staticClass: "attribute-picker-section" }, [
        _c("span", { staticClass: "sectionTitle" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.forwardSettingsTitle"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt-2" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.clone.forwardConfig.runAIFirstForce,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone.forwardConfig, "runAIFirstForce", $$v)
                  },
                  expression: "clone.forwardConfig.runAIFirstForce",
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("chatbotv2.forwardRunAiAfter")) +
                    "\n                "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt-2" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.clone.forwardConfig.forwardAllMessagesToAI,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.clone.forwardConfig,
                      "forwardAllMessagesToAI",
                      $$v
                    )
                  },
                  expression: "clone.forwardConfig.forwardAllMessagesToAI",
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("chatbotv2.forwardPriorMessagesToAi")) +
                    "\n                "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.clone.forwardConfig.runAIFirstForce
          ? _c(
              "div",
              { staticClass: "mt-2" },
              [
                _c("span", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("chatbotv2.forwardAiTriggerLabel"))),
                ]),
                _vm._v(" "),
                _c("TiptapEditor", {
                  attrs: {
                    placeholder: _vm.$t(
                      "chatbotv2.forwardAiTriggerPlaceholder"
                    ),
                    "show-attributes": true,
                    "show-emoji": false,
                  },
                  model: {
                    value: _vm.clone.forwardConfig.aiTriggerMessage,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.forwardConfig, "aiTriggerMessage", $$v)
                    },
                    expression: "clone.forwardConfig.aiTriggerMessage",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt-2" },
          [
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("chatbotv2.forwardChatbotTriggerLabel"))),
            ]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: _vm.$t(
                  "chatbotv2.forwardChatbotTriggerPlaceholder"
                ),
                "show-attributes": true,
                "show-emoji": false,
              },
              model: {
                value: _vm.clone.forwardConfig.chatbotTriggerMessage,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.clone.forwardConfig,
                    "chatbotTriggerMessage",
                    $$v
                  )
                },
                expression: "clone.forwardConfig.chatbotTriggerMessage",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    !_vm.clone.forwardConfig.runAIFirstForce
      ? _c("div", { ref: "initialBlockSection", staticClass: "mt-3" }, [
          _c(
            "div",
            { staticClass: "attribute-picker-section" },
            [
              _c("span", { staticClass: "sectionTitle" }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.forwardSelectInitialBlock"))),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  ref: "initialBlockSelect",
                  staticClass: "select-block",
                  attrs: {
                    value: _vm.clone.forwardConfig.initialBlockId,
                    showSearch: "",
                    placeholder: _vm.$t(
                      "chatbotv2.forwardSelectBlockPlaceholder"
                    ),
                    "filter-option": false,
                    size: "large",
                  },
                  on: {
                    change: _vm.handleBlockSelect,
                    search: _vm.handleBlockSearch,
                  },
                },
                _vm._l(_vm.getBlocks(), function (block) {
                  return _c(
                    "a-select-option",
                    { key: block.id, attrs: { value: block.id } },
                    [
                      _c(
                        "div",
                        { staticClass: "block-row" },
                        [
                          _c("BlockIconPreview", {
                            staticClass: "img",
                            attrs: { "block-type": block.type },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "blockTypeText" }, [
                            _vm._v(_vm._s(block.name || block.type)),
                          ]),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }